'use strict';

angular.module('licensure.services')
    .factory('ProcessEnterprises',  ['$http', '$q',  function ($http, $q ) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/processenterprises', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },
            
        }
    }])
;